import { createElement } from "react";
import reactRender from "~/lib/reactRenderer";

export default class ReactComponentElement extends HTMLElement {
  constructor() {
    super();
  }

  requireReadyAbortController;

  connectedCallback() {
    if (typeof window.require !== "function") {
      this.requireReadyAbortController = new AbortController();
      window.addEventListener("buildkite:require-ready", () => this.connectedCallback(), {
        once: true,
        signal: this.requireReadyAbortController.signal,
      });
      return;
    }

    const Component = window.require(this.getAttribute("path"));
    const args = JSON.parse(this.getAttribute("args"));

    reactRender(createElement(Component, args), this);
  }

  disconnectedCallback() {
    this.requireReadyAbortController?.abort();
  }
}

if (!window.customElements.get("react-component")) {
  window.ReactComponentElement = ReactComponentElement;
  window.customElements.define("react-component", ReactComponentElement);
}
